import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#4682b4',
          secondary: '#b0bec5',
          accent: '#8c9eff',
          error: '#b71c1c',
          success: '#1b8a4a',
          warning: '#b45309',
          muted: '#64748b',
        },
      },
    },
  },
})

// src/plugins/Vuetify.js
